export const updateTag = (tagName, keyName, keyValue, attrName, attrValue) => {
  const node = document.head.querySelector(`${tagName}[${keyName}="${keyValue}"]`);
  if (node && node.getAttribute(attrName) === attrValue) return;

  // Remove and create a new tag in order to make it work with bookmarks in Safari
  if (node) {
    node.parentNode.removeChild(node);
  }
  if (typeof attrValue === 'string') {
    const nextNode = document.createElement(tagName);
    nextNode.setAttribute(keyName, keyValue);
    nextNode.setAttribute(attrName, attrValue);
    document.head.appendChild(nextNode);
  }
};

export const updateMeta = (name, content) => {
  updateTag('meta', 'name', name, 'content', content);
};

export const updateCustomMeta = (property, content) => {
  updateTag('meta', 'property', property, 'content', content);
};

export const updateLink = (rel, href) => {
  updateTag('link', 'rel', rel, 'href', href);
};

/* eslint-disable no-param-reassign */
/**
 * Add class helper method
 * @param {DOMelement} element - the element to add a class to
 * @param {String} className - the class to add
 * @return {DOMelement} element the original element
 */
export const addClass = (element, className) => {
  if (element === null) {
    return element;
  }

  if (element.classList) {
    element.classList.add(className);
  } else {
    element.className += ` ${className}`;
  }
  return element;
};

/**
 * Has class helper method
 * @param {DOMelement} el - the element to add a class to
 * @param {String} className - the class to add
 * @return {Boolean} if the element has the class
 */
export const hasClass = (element, className) => {
  if (element.classList) {
    return element.classList.contains(className);
  }
  return new RegExp(`(^| )${className}( |$)`, 'gi').test(element.className);
};

/**
 * Remove class helper method
 * @param {DOMelement} el - the element to remove a class from
 * @param {String} className - the class to remove
 * @return {DOMelement} el the original element
 */
export const removeClass = (element, className) => {
  if (element.classList) {
    element.classList.remove(className);
  } else {
    const regex = new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi');
    element.className = element.className.replace(regex, ' ');
  }
  return element;
};

/**
 * Toggle class helper method
 * @param {DOMelement} el - the element to toggle a class
 * @param {String} className - the class to toggle
 * @return {DOMelement} el the original element
 */
export const toggleClass = (element, className) => {
  if (element.classList) {
    element.classList.toggle(className);
  } else {
    const classes = element.className.split(' ');
    const existingIndex = classes.indexOf(className);

    if (existingIndex >= 0) {
      classes.splice(existingIndex, 1);
    } else {
      classes.push(className);
    }
    element.className = classes.join(' ');
  }
  return element;
};
/* eslint-enable */
